import { QuestionCircleRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface HeadingProps {
  content: string;
  questionsCount: number;
}

function Heading({ content, questionsCount }: HeadingProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      <div className="text-2xl font-bold">{content}</div>
      <div className="flex gap-1">
        <QuestionCircleRegular fontSize={20} />
        <div className="text-cool-gray-600">
          {questionsCount} {t("question-counter")}
        </div>
      </div>
    </div>
  );
}

export default Heading;
